<span *ngFor="let path of paths">
    <a (click)="navigate(path)">{{ path.text }}</a>
    <span>></span>
  </span>
  